import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getBookingDomains } from "../../../../../api/services";
import { FormAutocomplete } from "../../../../../components/fields";
import { ReactQueryKey } from "../../../../../types";
import { IFormValuesBookingsFilter } from "../../../types";

const FormStutusList = () => {

    const { t } = useTranslation('booking');

    const statusListQuery = useQuery({
        queryKey: [ReactQueryKey.BookingDomains],
        queryFn: getBookingDomains,
        select: (data) => data.statuses,
        enabled: false
    });

    const handleOnOpen = () => {
        if(statusListQuery.data == undefined) 
            statusListQuery.refetch();
    }

    return (
        <FormAutocomplete<IFormValuesBookingsFilter>
            name="statusList"
            label={t('label.status')}
            options={statusListQuery.data ?? []}
            loading={statusListQuery.isLoading}
            isOptionEqualToValue={(option, value) => option?.code === value?.code}
            getOptionLabel={(option) => t(`status.${option.code}`)}
            multiple
            onOpen={handleOnOpen}
        />
    );
};

export default FormStutusList;
